import React from 'react';

const TemplateReceiveOrderFooter = () => {
  return (
    <div
      style={{
        position: 'absolute',
        left: 0,
        bottom: 0,
        width: '100%',
        padding: '30px',
      }}
    >
      <div className="grid grid-cols-8 gap-4">
        <div className="col-start-2 col-span-6">
          <div className="grid grid-cols-3 items-center text-sm font-bold gap-1">
            <div className="flex flex-col gap-2">
              <p className="text-center">ผู้รับสินค้า</p>
              <div className="h-24 grid grid-cols-1 gap-4 content-end border border-black p-2 items-center">
                <div className="text-center flex flex-col gap-2">
                  <div className="border-b border-black"></div>
                  <div className="border-b border-black text-left text-xs">
                    วันที่
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <p className="text-center">หัวหน้าสินค้า</p>
              <div className="h-24 grid grid-cols-1 gap-4 content-end border border-black p-2 items-center">
                <div className="text-center flex flex-col gap-2">
                  <div className="border-b border-black"></div>
                  <div className="border-b border-black text-left  text-xs">
                    วันที่
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <p className="text-center">ผู้ส่งสินค้า</p>
              <div className="h-24 grid grid-cols-1 gap-4 content-end border border-black p-2 items-center">
                <div className="text-center flex flex-col gap-2">
                  <div className="border-b border-black"></div>
                  <div className="border-b border-black text-left text-xs">
                    วันที่
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateReceiveOrderFooter;
